export enum DeepLinkType {
  ProviderId = 'provider_id',
  TapToPaySetup = 'ttp_setup',
  ChatId = 'chat_id',
}
